import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { globalStyle, style } from '@vanilla-extract/css';

export const filterItem = style({
  padding: `${space.s12}px ${space.s16}px`,
  display: 'flex',
  flexDirection: 'row',
  gap: space.s8,
  borderRadius: borderRadius.r12,
  outline: `1px solid ${themeVars.container.border.default}`,
  backgroundColor: themeVars.container.primary.background.idle,
  transition: 'background-color 0.15s ease-in-out',
  overflow: 'hidden',
  justifyContent: 'flex-start',

  selectors: {
    '&:hover': {
      backgroundColor: themeVars.controls.background.hover,
    },
  },
});

export const filterItemContent = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  flex: 1,
});

export const manageFiltersContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
});

export const filterItemTitle = style({
  ...typography.titleMd,
  fontWeight: 700,
  wordBreak: 'break-word',
});

export const filterItemPrompt = style({
  ...typography.bodyMd,
  color: themeVars.container.foreground.secondary,
  wordBreak: 'break-word',
  display: '-webkit-box',
  WebkitLineClamp: 5,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const filterItemAside = style({
  opacity: '0',
  display: 'flex',
  flexDirection: 'row',
  gap: space.s4,
  alignItems: 'center',
  marginLeft: 'auto',
  transition: 'opacity 0.15s',

  '@media': {
    '(hover: none) and (pointer: coarse)': {
      opacity: '1',
    },
  },
});

globalStyle(`.${filterItem}:hover ${filterItemAside}`, {
  opacity: '1',
});

export const filterItemCollectionsList = style({
  margin: 0,
  marginTop: space.s8,
  marginBottom: space.s16,
  paddingLeft: space.s20,
  wordBreak: 'break-word',
});

export const filterItemCollectionsContainer = style({
  ...typography.bodyMd,
  display: 'flex',
  flexDirection: 'row',
  gap: space.s12,
  padding: `${space.s16}px ${space.s24}px`,
  backgroundColor: themeVars.container.primary.background.idle,
  color: themeVars.container.foreground.tertiary,
  borderRadius: borderRadius.r25,
  marginTop: space.s16,
});

export const filterItemConfirmDeleteDescription = style({
  ...typography.bodyMd,
  color: themeVars.container.foreground.tertiary,
});

export const filterItemCollectionsLabel = style({
  ...typography.labelMd,
  color: themeVars.container.foreground.primary,
});
